import * as React from "react";

import { Route, Switch } from "react-router";
import ContactFormIndex from "~/pages/ContactForm/ContactFormIndex";
import DashboardIndex from "~/pages/Dashboard/DashboardIndex";
import FAQIndex from "~/pages/FAQ/FAQIndex";
import TrackTraceIndex from "~/pages/TrackTrace/TrackTraceIndex";
import TrackTraceShow from "~/pages/TrackTrace/TrackTraceShow";
import B2BIndex from "./pages/B2B/B2BIndex";
import ContactFormThankYou from "./pages/ContactForm/ContactFormThankYou";
import GiftCardIndex from "./pages/GiftCard/GiftCardIndex";
import RMAFormIndex from "./pages/RMA/RMAFormIndex";
import RMAThankYou from "./pages/RMA/RMAThankYou";

export default class Routes extends React.Component {
  public render() {
    return (
      <Switch>
        <Route
          strict={true}
          path="/track-trace/:postalCode/:orderNumber"
          component={TrackTraceShow}
        />
        <Route path="/track-trace" component={TrackTraceIndex} />
        <Route path="/faq/:topic/:question" component={FAQIndex} />
        <Route path="/faq/:topic" component={FAQIndex} />
        <Route path="/faq" component={FAQIndex} />
        <Route path="/contact/thank-you" component={ContactFormThankYou} />
        <Route path="/contact/:reason" component={ContactFormIndex} />
        <Route path="/contact" component={ContactFormIndex} />
        <Route path="/rma/request" component={RMAFormIndex} />
        <Route path="/rma/thank-you" component={RMAThankYou} />
        <Route path="/b2b" component={B2BIndex} />
        <Route path="/giftcard/:question" component={GiftCardIndex} />
        <Route path="/giftcard" component={GiftCardIndex} />
        <Route path="/" component={DashboardIndex} />
      </Switch>
    );
  }
}



// WEBPACK FOOTER //
// ./src/routes.tsx